import { render } from "./CurrencyConversion.vue?vue&type=template&id=20db41a0&lang=pug"
import script from "./CurrencyConversion.vue?vue&type=script&lang=js"
export * from "./CurrencyConversion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__